module.exports = __webpack_public_path__ + "img/i-order.eed5d08.svg";